// Importaciones de interfaces.
import { IRole } from '../interfaces/role.interface';

/**
 * Clase que representa un rol.
 *
 * Esta clase contiene información relevante sobre un rol, incluyendo
 * el nombre y el identificador del rol dentro de la aplicación.
 */
export class Role implements IRole {
  /**
   * Identificador único del rol.
   *
   * Este campo representa un identificador único asignado al rol.
   * Puede ser un número o nulo si no está asignado.
   */
  id: number | null;

  /**
   * Nombre del rol.
   *
   * Este campo almacena el nombre del rol.
   * Puede ser nulo si no se ha establecido.
   */
  name: string | null;

  /**
   * Nombre para mostrar del rol.
   *
   * Este campo define el nombre visible del rol, el cual es utilizado en interfaces de usuario.
   * Puede ser nulo si no se ha definido.
   */
  displayName: string | null;

  /**
   * Constructor de la clase que inicializa una instancia de IRole.
   *
   * @param {Partial<IRole>} role - Un objeto parcial de IRole que contiene las propiedades opcionales:
   *   - `id` (opcional): Identificador del rol. Por defecto, `null`.
   *   - `name` (opcional): Nombre interno del rol. Por defecto, `null`.
   *   - `displayName` (opcional): Nombre visible del rol. Por defecto, `null`.
   */
  constructor({
    id = null,
    name = null,
    displayName = null,
  }: Partial<IRole> = {}) {
    this.id = id;
    this.name = name;
    this.displayName = displayName;
  }
}
